import { EMAIL_ERRORS } from "../../../common/constants/agentModule/emailContants";
import { EMAIL_CONVERSATION_URLS } from "../../apiConfig";
import apiClient from "../../apiInstance";

export const getEmailsInfo = async () => {
    try {
      const response = await apiClient.get(EMAIL_CONVERSATION_URLS.FETCH_EMAIL_CONVERSATION_INFO);
      return response.data;
    } catch (error) {
      console.error(EMAIL_ERRORS.FETCH_EMAIL_INFO_ERROR, error);
      throw error;
    }
  };

  // Get email data
export const getEmailConversationById = async (customerdataid) => {
    try {
      const response = await apiClient.get(EMAIL_CONVERSATION_URLS.FETCH_Email_CONVERSATION_BY_ID, {
        params: { customerdataid: customerdataid }, // Explicitly setting the key-value pair
      });
      return response.data;
    } catch (error) {
      console.error(EMAIL_ERRORS.FETCH_EMAIL_CONVERSATION_BY_ID_ERROR, error);
      throw error;
    }
  };

  // Save email response
export const saveEmailResponse = async ({ emailconvid, content, subject, userguid }) => {
    try {
      const response = await apiClient.post(EMAIL_CONVERSATION_URLS.SAVE_EMAIL_RESPONSE, {
        emailconvid,
        content, // Pass the email content
        subject, // Pass the email subject
        userguid
      });
      return response.data;
    } catch (error) {
      console.error(EMAIL_ERRORS.SAVE_EMAIL_RESPONSE_ERROR + ` (emailconvid: ${emailconvid}):`, error);
      throw error;
    }
  };

  // Send email response
export const sendEmailResponse = async ({ emailconvid, content, subject, userguid }) => {
    try {
      const response = await apiClient.post(EMAIL_CONVERSATION_URLS.SEND_EMAIL_RESPONSE, {
        emailconvid,
        content, // Pass the email content
        subject, // Pass the email subject
        userguid // Pass the userguid
      });
      return response.data;
    } catch (error) {
      console.error( EMAIL_ERRORS.SEND_EMAIL_RESPONSE_ERROR + `(emailconvid: ${emailconvid}):`, error);
      throw error;
    }
  };